import React from "react";
import format from "date-fns/format";
import { useHistory } from "react-router";

import constants, { getDashboardPath } from "../../../../constants";
import { ACCEPT_APPOINTMENT } from "../../../../constants";
import { parseDateToLocal } from "../../../../utils/parseDateTime";
import { convertTimeTo12HourFormat } from "../../../../utils/parseDateTime";
import Modal from "../../../../components/uiElements/popupModal/modal";
import Button from "../../../../components/formElements/button/Button";

const AcceptModal = props => {
  const history = useHistory();

  const modalType = props.isOpen;

  const { appointmentData } = props;

  const acceptStyles = {
    content: {
      minWidth: "552px",
      maxWidth: "552px",
      minHeight: "480px",
      maxHeight: "480px",
    },
  };

  const btnDark =
    (modalType === "deny" && {
      label: "Deny",
      onclick: () => {
        props.closeModal();
        props.onUpdate(
          appointmentData?.id,
          constants.APPOINTMENT_STATUS.denied,
          () => props.onAcceptSuccess()
        );
      },
    }) ||
    (modalType === "reschedule" && {
      label: "Reschedule",
      onclick: () => {
        props.closeModal();
        props.onUpdate(
          appointmentData?.id,
          constants.APPOINTMENT_STATUS.rescheduleRequest,
          () => props.onAcceptSuccess()
        );
      },
    }) ||
    (modalType === "cancel" && {
      label: "Cancel",
      onclick: () => {
        props.closeModal();
        props.onUpdate(
          appointmentData?.id,
          constants.APPOINTMENT_STATUS.cancelled,
          () => props.onAcceptSuccess()
        );
      },
    });
  return (
    <Modal
      {...props}
      styles={modalType === "accept" && acceptStyles}
      title={
        (modalType === "deny" && "Deny Appointment Request") ||
        (modalType === "reschedule" && "Reschedule Appointment Request") ||
        (modalType === "cancel" && "Cancel Scheduled Appointment")
      }
      btnDark={btnDark}
    >
      <div className="p-5">
        <button
          onClick={props.closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        {props.isOpen === "accept" && (
          <div className="text-center mx-auto">
            <img src={ACCEPT_APPOINTMENT} alt="success-calendar" />
            <p className="mt-4 mb-0 appointment-accept__text">
              Alright Dr. {props?.personalInfo?.firstName}{" "}
              {props?.personalInfo?.lastName} !
            </p>
            <p className="appointment-accept__text">
              you have confirmed appointment with {appointmentData.patientName}
            </p>
            <p className="appointment-accept__slot">
              {convertTimeTo12HourFormat(appointmentData.startTime)} | {appointmentData.patientName}{" "}
            </p>
            <p className="appointment-accept__date">
              {format(
                parseDateToLocal(appointmentData.appointmentDate),
                "EEEE, MMMM dd, yyyy"
              )}
            </p>
            <p className="appointment-accept__date">
              Topic : {appointmentData.topic}
            </p>
            <Button
              label="My Appointments"
              className="h-75 mt-3"
              onClick={() => {
                props.closeModal();
                history.push(getDashboardPath("/appointments/scheduled"));
              }}
            />
          </div>
        )}
        {props.isOpen === "deny" && (
          <p className="text-center m-auto denyAppointmentText">
            Are you sure you want to deny appoinment request from{" "}
            {appointmentData.patientName}.
          </p>
        )}
        {props.isOpen === "reschedule" && (
          <p className="text-center m-auto denyAppointmentText">
            Are you sure you want to reschedule appoinment{" "}
            {!props.rescheduleType && "request"} from{" "}
            {appointmentData.patientName}.
          </p>
        )}
        {props.isOpen === "cancel" && (
          <p className="text-center m-auto denyAppointmentText">
            Are you sure you want to cancel appoinment from{" "}
            {appointmentData.patientName}.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default AcceptModal;
